import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./Header.css";

export default function Header({ cartCount, wishlistCount }) {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const navigate = useNavigate();
  const profileRef = useRef(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 992);
    handleResize();
    window.addEventListener("resize", handleResize);

    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("resize", handleResize);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const navItems = [
    { name: "Home", path: "/", icon: "ri-home-4-line" },
    { name: "Prebuilt", path: "/prebuilt", icon: "ri-computer-line" },
    { name: "Custom", path: "/custom", icon: "ri-settings-3-line" },
    { name: "Support", path: "/support", icon: "ri-headphone-line" },
    { name: "Test Page", path: "/test", icon: "ri-file-list-line" },
  ];

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };

  return (
    <div className="header">
      <nav className="navbar">
        {isMobile && (
          <div className="hamburger" onClick={() => setOpen(true)}>
            <i className="ri-menu-line"></i>
          </div>
        )}

        <div className="logo">
          <img src="/images/logo/logo.jpeg" alt="Website Logo" />
        </div>

        {!isMobile && (
          <ul className="nav-links">
            {navItems.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.path}
                  end
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <i className={item.icon}></i>
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        )}

        <div className="nav-buttons">
          <div className="icon-wrapper">
            <i className="ri-heart-fill"></i>
            {wishlistCount > 0 && <span className="badge">{wishlistCount}</span>}
          </div>

          <div className="icon-wrapper">
            <i className="ri-shopping-cart-2-line"></i>
            {cartCount > 0 && <span className="badge">{cartCount}</span>}
          </div>

          {/* Profile */}
          <div
            className="icon-wrapper profile"
            ref={profileRef}
            onClick={() => setProfileOpen((prev) => !prev)}
          >
            <i className="ri-user-fill"></i>
            {profileOpen && (
              <ul className="profile-dropdown">
                <li onClick={() => navigate("/profile")}>Profile</li>
                <li onClick={handleLogout}>Logout</li>
              </ul>
            )}
          </div>
        </div>
      </nav>

      {isMobile && (
        <>
          <div className={`sidebar ${open ? "show" : ""}`}>
            <div className="close-btn" onClick={() => setOpen(false)}>
              <i className="ri-close-line"></i>
            </div>
            <ul>
              {navItems.map((item) => (
                <li key={item.name}>
                  <NavLink to={item.path} end onClick={() => setOpen(false)}>
                    <i className={item.icon}></i>
                    {item.name}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
          {open && <div className="backdrop" onClick={() => setOpen(false)}></div>}
        </>
      )}
    </div>
  );
}
